<span class="sa-chip-wrapper">
  <ng-container *ngFor="let technology of technologiesList | slice:0:displayNumber; let last = last;">
    <span class="new-p-chip" appStopPropagation container="body">{{technology}}</span>{{last ? '' : ' '}}
  </ng-container>
  <ng-container *ngIf="moreTechnologies > 0">
    <a class="more-technologies" href="javascript:;" (click)="open()" appStopPropagation>+{{moreTechnologies}}</a>
  </ng-container>
</span>
